import { render, staticRenderFns } from "./IconsParam.vue?vue&type=template&id=64d5c350"
import script from "./IconsParam.vue?vue&type=script&lang=js"
export * from "./IconsParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports